import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { IMG } from "@/lib/content";
import { PricingTable, IncludeList } from "@/components/Pricing";

export default function AirbnbTurnover() {
  const [service, setService] = useState(null);
  useEffect(() => { api.get("/services").then((r) => setService(r.data.find((s) => s.slug === "airbnb"))).catch(() => {}); }, []);

  return (
    <div>
      <section className="relative h-[46vh] min-h-[340px]">
        <img src={IMG.turnoverBed} alt="Guest-ready bedroom with fresh linens" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-overlay" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex flex-col justify-end pb-12">
          <p className="text-xs uppercase tracking-[0.25em] text-white/90">For short-term rental hosts</p>
          <h1 className="mt-2 font-serif text-4xl sm:text-5xl text-white font-semibold">Airbnb Turnover Cleaning</h1>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-3 gap-12">
        <div className="lg:col-span-2 space-y-6">
          <p className="text-lg text-[#635B52] leading-relaxed">
            Reliable, hotel-standard resets between guests so every arrival feels five-star. Pricing applies to
            <strong className="text-[#2C2621]"> routinely maintained short-term rentals</strong>. Clean linens must be available on-site.
          </p>
          <div className="bg-[#F5F0E8] border-l-4 border-[#B87333] rounded-r-xl p-5 text-[#2C2621]">
            Laundry, specialty add-ons, excessive mess, and unusual property conditions cost extra.
          </div>
          <h2 className="font-serif text-2xl text-[#2C2621] pt-2">Every turnover includes</h2>
          <IncludeList items={[
            "Fresh bed-making with your on-site clean linens",
            "Bathroom sanitizing and restock check",
            "Kitchen wipe-down and dish reset",
            "Floors vacuumed and mopped",
            "Trash removal and surface dusting",
            "Staging for a crisp, guest-ready look",
          ]} />
        </div>
        <div className="bg-white rounded-2xl border border-[#E6DEC3] p-6 h-fit shadow-[0_4px_20px_rgba(44,38,33,0.04)]">
          <h3 className="font-serif text-xl text-[#2C2621]">Why hosts choose us</h3>
          <ul className="mt-4 space-y-2 text-sm text-[#635B52]">
            <li>• Consistent, dependable timing</li>
            <li>• Protects your review score</li>
            <li>• Add laundry & restock as needed</li>
          </ul>
          <Link to="/book?service=airbnb" className="mt-6 block text-center bg-[#B87333] hover:bg-[#A06127] text-white font-medium rounded-full px-5 py-3 transition-all" data-testid="airbnb-book-btn">Book a turnover</Link>
        </div>
      </div>

      <section className="bg-[#F5F0E8] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-serif text-3xl text-[#2C2621] mb-8">Turnover pricing</h2>
          <PricingTable service={service} />
        </div>
      </section>
    </div>
  );
}
